import React from 'react';
import { Alert, Box, CircularProgress, Container } from '@mui/material';
import useAdminKnowledgeBase from './useAdminKnowledgeBase';
import KnowledgeBaseHeader from './KnowledgeBaseHeader';
import KnowledgeStatsCards from './KnowledgeStatsCards';
import KnowledgeInfoBanner from './KnowledgeInfoBanner';
import KnowledgeFilters from './KnowledgeFilters';
import KnowledgeTable from './KnowledgeTable';
import KnowledgePagination from './KnowledgePagination';

const AdminKnowledgeBasePage = () => {
  const {
    companies,
    isCompaniesLoading,
    isCompaniesError,
    selectedClientId,
    knowledge,
    isKnowledgeLoading,
    isKnowledgeError,
    parsed,
    pagedRows,
    pageCount,
    currentPage,
    total,
    hasActiveFilters,
    bannerMessage,
    showEmptyClients,
    showKnowledge,
    isCompact,
    isTablet,
    tableTopRef,
    handleClientChange,
    handleClear,
    handleSort,
    handlePageChange,
    updateState,
  } = useAdminKnowledgeBase();

  return (
    <Container maxWidth={false} sx={{ my: { xs: 2, md: 4 }, px: { xs: 2, md: 3 }, width: '100%', maxWidth: '100%' }}>
      <KnowledgeBaseHeader
        companies={companies}
        selectedClientId={selectedClientId}
        isCompaniesLoading={isCompaniesLoading}
        onClientChange={handleClientChange}
      />

      {isCompaniesLoading && (
        <Box display='flex' justifyContent='center' py={10}>
          <CircularProgress aria-label='Loading clients' />
        </Box>
      )}

      {isCompaniesError && (
        <Alert severity='error' sx={{ borderRadius: 2 }}>
          Could not load clients. Refresh the page and try again.
        </Alert>
      )}

      {showEmptyClients && (
        <Alert severity='info' sx={{ borderRadius: 2 }}>
          No clients found. Add a client company before browsing Knowledge Base content.
        </Alert>
      )}

      {showKnowledge && isKnowledgeError && (
        <Alert severity='error' sx={{ borderRadius: 2 }}>
          Could not load knowledge for this client. Refresh the page and try again.
        </Alert>
      )}

      {showKnowledge && isKnowledgeLoading && (
        <Box display='flex' justifyContent='center' py={10}>
          <CircularProgress aria-label='Loading knowledge' />
        </Box>
      )}

      {showKnowledge && !isKnowledgeLoading && !isKnowledgeError && (
        <>
          <KnowledgeStatsCards stats={knowledge.stats} />
          <KnowledgeInfoBanner message={bannerMessage} />
          <KnowledgeFilters
            search={parsed.search}
            source={parsed.source}
            sources={knowledge.sources}
            hasActiveFilters={hasActiveFilters}
            onSearchChange={(search) => updateState({ search })}
            onSourceChange={(source) => updateState({ source })}
            onClear={handleClear}
          />
          <KnowledgeTable
            rows={pagedRows}
            hasActiveFilters={hasActiveFilters}
            sortBy={parsed.sortBy}
            sortDir={parsed.sortDir}
            isTablet={isTablet}
            onSort={handleSort}
            tableTopRef={tableTopRef}
          />
          <KnowledgePagination
            total={total}
            pageCount={pageCount}
            currentPage={currentPage}
            isCompact={isCompact}
            isTablet={isTablet}
            onPageChange={handlePageChange}
          />
        </>
      )}
    </Container>
  );
};

export default AdminKnowledgeBasePage;
